import { c as _c } from "react/compiler-runtime";
import { css, cx } from '@repo/pandacss/css';
import { type CtaAnalyticsProps, CtaLink } from '../../CTA/CtaLink';
import { StarRatingTooltip } from '../StarRatingTooltip';
const styles = {
  ratingTextRow: css({
    display: 'flex',
    alignItems: 'flex-start',
    mt: '[1px]',
    _pcMd: {
      ml: '[10px]'
    }
  }),
  ratingTextLink: css({
    position: 'relative'
  }),
  ratingTextLabel: css({
    fontSize: '[13px]',
    lineHeight: '[1.5]',
    _pcMd: {
      fontSize: '1rem'
    }
  }),
  tooltipIconWrapper: css({
    display: 'inline',
    ml: '[3px]',
    position: 'relative',
    top: '[1px]',
    _pcMd: {
      ml: '[5px]',
      top: '[2px]'
    }
  })
} as const;
export function RatingTextAndTooltip(t0) {
  const $ = _c(11);
  const {
    analytics,
    reviewLink,
    isMonetizing,
    segmentActionSection: t1,
    name
  } = t0;
  const segmentActionSection = t1 === undefined ? "roundup_recommendations" : t1;
  let t2;
  if ($[0] !== analytics || $[1] !== name || $[2] !== reviewLink) {
    t2 = reviewLink ? <CtaLink css={{
      textStyle: "body.responsive"
    }} underline="hover" href={reviewLink} target="_blank" className={cx(styles.ratingTextLink, styles.ratingTextLabel)} analytics={analytics} parameterActions={[]} aria-label={`Read NerdWallet's review of ${name}`} skipShoppingFinishedEvent={true} isReview={true}>NerdWallet rating</CtaLink> : <span className={styles.ratingTextLabel}>NerdWallet rating</span>;
    $[0] = analytics;
    $[1] = name;
    $[2] = reviewLink;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = css.raw({
      maxWidth: "[17.25rem]"
    });
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== isMonetizing || $[6] !== segmentActionSection) {
    t4 = <div className={styles.tooltipIconWrapper}><StarRatingTooltip isMonetizing={isMonetizing} segmentActionSection={segmentActionSection} popupCss={t3} /></div>;
    $[5] = isMonetizing;
    $[6] = segmentActionSection;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t4) {
    t5 = <div className={styles.ratingTextRow}>{t2}{t4}</div>;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}